import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

// Component for Variables content
const CollectionVariables = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box style={{
            display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, overflowY: 'auto',
            p: 3
        }}>
            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <strong>Collection Variables</strong>
                <br />
                <br />
                <p>
                    Collection variables are user-defined key-value pairs scoped at the
                    collection level. They are accessible to all requests, scripts, and flows
                    defined within the same collection.
                </p>
                <p>
                    These variables are particularly useful for storing shared data such as
                    base URLs, tokens, or default request parameters that apply across all
                    requests in a collection. Instead of hardcoding values or repeating them
                    in every request, you can define them once here and reuse using the
                    double curly braces syntax like <code>`{`{{baseUrl}}`}`</code>.
                </p>
                <p>
                    Collection variables are stored alongside the collection file (in YAML)
                    and are easily trackable and version-controlled with Git.
                </p>
                <p>
                    <strong>Example use case:</strong> If your API base URL is 
                    <code> https://api.example.com</code>, you can define a variable
                    <code>baseUrl</code> here, and use <code>`{`{{baseUrl}}`}`</code> in all your
                    endpoints.
                </p>
            </Typography>
            <img
                src="/docs/collectionVariables.png"
                alt="validations"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    // maxWidth: '800px',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                }}
            />

            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <p>
                    Variable precedence determines which variable is used when there are
                    duplicates across different scopes. In HawkClient, the order of
                    precedence is:
                </p>
                <ol style={{ paddingLeft: '20px' }}>
                    <li><strong>Request Variables</strong></li>
                    <li><strong>Environment Variables</strong></li>
                    <li><strong>Collection Variables</strong></li>
                    <li><strong>Global Variables</strong></li>
                </ol>
                <p>
                    This means Collection Variables will override Global Variables, but will
                    be overridden by Environment or Request-specific variables if present.
                </p>
            </Typography>
        </Box>
    )
};

export default CollectionVariables;